import {
  EAdvertisementStatus,
  IMyAdvertisement,
  TAdvertisementItem,
} from 'types';

export enum EAdvertisementItem {
  PublicAdvertisement = 'PublicAdvertisement',
  MyAdvertisement = 'MyAdvertisement',
}

export enum EAdvertisementCategories {
  ALL = 'ALL',
  GOODS = 'GOODS',
  SERVICES = 'SERVICES',
}

export interface IMyAdvertisementStatus {
  title: string;
  value: EAdvertisementStatus;
  active: boolean;
}

export interface IModalAdvertisementManagerState {
  mode: 'create' | 'edit';
  advertisement?: IMyAdvertisement;
}
export interface IModalAdvertisementViewState {
  mode: 'my' | 'other';
  advertisement?: TAdvertisementItem;
}
